import React, { Component } from 'react';
import { cloneDeep, debounce } from 'lodash';
import {Col, Form, Input, Modal, Row, Select} from 'antd';
import Resources from '../scripts/resources';
import Rules from '../scripts/rules';
import API from "../scripts/api";

class SetPRTypeForm extends Component {
    constructor() {
        super();

        this.state = {
            products: [],
            selected: {},
            selectedValues: []
        };

        this.formRef = React.createRef();
    }

    handleSubmit = () => {
        this.formRef.current.validateFields().then(values => {
          console.log(values)
            this.props.onSubmit(values);
        });
    }

    handleWillUnmount = () => {
        this.formRef.current.resetFields();
    }

    handleDidMount = (data = {}, categoryType) => {
        this.formRef.current.setFieldsValue({p_r_type_id : data?.p_r_type_id?._id});
        this.setState({ editMode: !!data._id, selected: data });
        let selectedValues = []
        if(data.p_r_type_id){
          selectedValues.push({
            label: data.p_r_type_id.title,
            value: data.p_r_type_id._id
          })
          this.setState({  selectedValues:  selectedValues,  PRTypesOptions: selectedValues});
        }
    }

    render() {
        const { onCancel, submitting, visible } = this.props;
        const { editMode, products, PRTypesOptions, selectedValues } = this.state;
      const searchPRTypes = debounce(async (searchText) => {
          API.PRType.search( {q: searchText, page: 1})
            .then(async (result) => {
              let PRTypesOptions = []
              await result.data.map((item) =>
                PRTypesOptions.push( {
                  label: item.title,
                  value: item._id
                })
              )
          this.setState({PRTypesOptions: PRTypesOptions})
        })
        .catch(() => {
          this.setState({ submitting: false });
        });
      }, 500); // debounce to avoid too many requests
        return (
            <Modal
                title={editMode ? Resources.edit : Resources.add}
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={onCancel}
                okText={Resources.confirm}
                cancelText={Resources.cancel}
                okButtonProps={{ loading: submitting }}
                cancelButtonProps={{ disabled: submitting }}
                width={360}>
                <Form ref={this.formRef} layout="vertical">
                  
                    
                  <Col xs={24} md={24}>
                    <Form.Item
                      name="p_r_type_id"
                      label={`${Resources.productRelationType} `}
                    >
                      <Select
                        allowClear
                        showSearch
                        placeholder="Search and select items"
                        filterOption={false} // disable local filtering
                        onSearch={searchPRTypes} // search triggers API
                        // onChange={setSelectedValues}
                        options={PRTypesOptions}
                        value={selectedValues}
                      />  
                    </Form.Item>
                                                            
                  </Col>

                </Form>
            </Modal>
        );
    }
};

export default SetPRTypeForm;